import { DeleteOutline as DeleteIcon } from '@mui/icons-material';
import { Box, styled } from '@mui/material';

export const CircleContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.light,
  marginBottom: theme.spacing(3),
  borderRadius: '50%',
  width: '80px',
  height: '80px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledDeleteIcon = styled(DeleteIcon)({
  color: '#fff',
});
